// Configuration centralisée de l'API
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Fonction utilitaire pour construire les URLs complètes
export const getApiUrl = (endpoint: string): string => {
  // Supprimer le slash de début si présent
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};




